import "./login.css";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import React from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import createApiClient from "../../utils/axiosConfig";
import WhitefriarLogo from "../../assets/imges/Whitefriar-logo.png";

function Login() {
  const api = createApiClient(process.env.REACT_APP_API_URL);
  const navigate = useNavigate();
  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const response = await api.post(`signin`, values);
      if (response.status === 200) {
        if (response?.data.data?.role === 1) {
          localStorage.setItem("adminToken", response.data.token);
          localStorage.setItem("adminLogin", 1);
          localStorage.setItem(
            "adminData",
            JSON.stringify(response?.data.data)
          );
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("userdata", JSON.stringify(response?.data.data));
          navigate("/admin");
        } else {
          toast.error("Only Admin have access not users");
        }
        resetForm();
      } else {
        navigate("/admin-login");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="login-card">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form className="login-form">
                <div className="logo-container">
                  <img 
                    src={WhitefriarLogo} 
                    alt="Whitefriar Logo" 
                    className="logo"
                  />
                </div>
                <h3 className="login-title">Admin Sign In</h3>
                <p className="login-subtitle">Welcome back! Please sign in to your account.</p>
                
                <div className="form-group">
                  <Field
                    type="email"
                    name="email"
                    className="form-input"
                    placeholder="Enter your email"
                  />
                  <ErrorMessage
                    name="email"
                    component="div"
                    className="error-message"
                  />
                </div>
                
                <div className="form-group">
                  <Field
                    type="password"
                    name="password"
                    className="form-input"
                    placeholder="Enter your password"
                  />
                  <ErrorMessage
                    name="password"
                    component="div"
                    className="error-message"
                  />
                </div>
                
                
                <button
                  type="submit"
                  className="login-button"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Signing in..." : "Sign In"}
                </button>
              </Form>
            )}
          </Formik>
          
          <div className="login-footer">
            <p>
              Copyright © <span>Whitefriar</span> 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
